export const getPersonalPensionPlanState = (state) => state?.personalPensionPlan;
